import React from 'react';
import { TFunction } from 'i18next';
import { WidgetsKindEnum } from 'graphql-common';
import { FieldItem, Values } from '@lib/interfaces/form';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageIconColor,
  SupportiveMessageType,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import WidgetFieldNames from '@lib/enums/fieldNames/widgetFieldNames';
import { isWidgetSelected } from './validationHelpers';

/**
 * Returns fields for Sites Map widget
 */
export default function getSitesMapFields(t: TFunction): FieldItem[] {
  return [
    {
      name: WidgetFieldNames.SitesMapInfo,
      customRender: () => (
        <SupportiveMessage
          text={t('home.widget-sites-map-info')}
          leftIcon="info"
          color={SupportiveMessageColor.Gray}
          iconColor={SupportiveMessageIconColor.Inner}
          type={SupportiveMessageType.Transparent}
          hasBottomSpace={false}
        />
      ),
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.SitesMap),
    },
  ];
}
